export default __webpack_public_path__ + "static/media/origins_of_the_rivalry_2.f57ecdb6.png";